import { useRef, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { useMenu, usePlace } from "./ui";

// A MenuItem is a choice; with checked set, one of a set shown ticked (or,
// with toggle, a choice of its own turned on or off); with heading set, a
// label over the choices after it; with divider set, a line above it.
// icon goes before the label, and title is said on hovering it.
export type MenuItem = { label: string; run?: () => void; danger?: boolean; checked?: boolean; toggle?: boolean; heading?: boolean; divider?: boolean; icon?: ReactNode; title?: string };

// PopMenu is a small menu by the button that opened it; it closes on a
// pick, a click elsewhere, or Escape. win is the window it opens in, as a
// call's own window.
export function PopMenu({ anchor, label, items, onClose, win = window }: { anchor: DOMRect; label: string; items: MenuItem[]; onClose: () => void; win?: Window }) {
  const ref = useRef<HTMLUListElement>(null);
  useMenu(ref, onClose, { win });
  const style = usePlace(ref, anchor, {}, win);
  return createPortal(
    <ul ref={ref} className="pop-menu" role="menu" aria-label={label} style={style}>
      {items.map((it, i) =>
        it.heading ? (
          <li key={i} className={`pop-heading ${it.divider ? "divider" : ""}`} role="presentation">
            {it.label}
          </li>
        ) : (
          <li key={i} className={it.divider ? "divider" : ""} role="none">
            <button
              role={it.checked === undefined ? "menuitem" : it.toggle ? "menuitemcheckbox" : "menuitemradio"}
              aria-checked={it.checked}
              className={it.danger ? "danger" : ""}
              title={it.title}
              onClick={() => (it.run?.(), onClose())}
            >
              {it.checked !== undefined && <span className="pop-check">{it.checked ? "✓" : ""}</span>}
              {it.icon}
              <span className="pop-label">{it.label}</span>
            </button>
          </li>
        ),
      )}
    </ul>,
    win.document.body,
  );
}
